export const environment = {
	production: false,
	beta: true,
	local: false,
	storeDomain: 'certmetrics.com',
	apiUrl: 'https://beta-api.certmetrics.com',
	graphQLUrl: 'https://beta-api.certmetrics.com/gql',
	logging: 0,
	cpUrl: 'https://beta-cp.certmetrics.com/',
	spUrl: 'https://beta-sp.certmetrics.com/',
	ipUrl: 'https://beta-ip.certmetrics.com/',
	processDelayInMS: 7000,
	importErrorTimeout: 10000,
};
